import axios from "axios";
import api, { APIClient } from "../../api";
import { SavingPlanReserveModel } from "./FinOpsSavingPlanReserveModel";

const mockApi = axios.create({
    baseURL: 'http://localhost:3001', // Defina uma baseURL fictícia
});

export class FinOpsSavingPlanReserveService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    baseURL = 'http://localhost:3000';

    getSavingPlanReserve = async (): Promise<SavingPlanReserveModel[]> => {
        const url = `${this.baseURL}/finops/GetSavingPlanAndReserve`;
        return (await mockApi({
            method: 'get',
            url,
        })).data;
    }

    retrieveList = async (): Promise<SavingPlanReserveModel[]> => {
        const url = `${this.endpoint}/api/SavingsAndReserves/RetrieveList`;
        let result = await api({
            method: 'get',
            url,
        });

        return result.data as SavingPlanReserveModel[];
    }

}